module.exports = __webpack_public_path__ + "static/media/Ian.b9f9a7b5.jpg";